module.exports = __webpack_public_path__ + "static/emm-004-a76e67ddc288ddc8b9a46b9148fc3601.jpg";